import React, { useEffect, useRef, useState } from 'react';
import { ImageBackground, ImageBackgroundProps, ImageSourcePropType, ScrollView, TouchableWithoutFeedback, KeyboardAvoidingView, NativeSyntheticEvent, PixelRatio, Platform, StyleSheet, Text, TextInput, TextInputSubmitEditingEventData, View } from 'react-native';

import Icon from 'react-native-vector-icons/FontAwesome';
import { useDimensions } from 'react-native-web-hooks';
import useFontSize from '../../shell/hooks/useFontSize';
import ImageClass from '../../shell/Image';
import { isMobile } from '../../shell/utils/platformCheck';
import { WaitForLoadImage } from '../../shell/ImageHandler/WaitForLoadImage';
import { useAppSelector } from '../../store/hooks';
import { setSeenImage } from '../../store/slices/AdvanceSlice';
import { TimageINT } from '../../store/slices/gameObjectSlice';
import { setInstaImage } from '../../store/slices/instaSlice';
import { selectMenu } from '../../store/slices/menuSlice';
import { store } from '../../store/store';
import { nFormatter } from '../../utils/nFormatter';
import TTalkContainer from '../TTalkContainer';
import { InstaAvatar } from './InstaAvatar';
import { InstaImage, InstaProfileINT } from './interfaces';
import { mc } from '../../../game/characters/MC';




interface InstaPostProps {
    instaProfile: InstaProfileINT,
    selectedImage: InstaImage,
    user: string;
}

export const InstaPost: React.FC<InstaPostProps> = React.memo(({ instaProfile, selectedImage, user: userName }) => {
    // TODO: fix bug - when you like or comment on image with additional images they go back to the start.

    const scrollViewRef = React.useRef<ScrollView>(null);
    const [additionalImage, setAdditionalImage] = useState<{ image: ImageSourcePropType | null | undefined, index: number, length: number; }>();
    const menuSlice = useAppSelector(selectMenu);

    const inputTextRef = useRef<TextInput | null>();
    const { width, height } = useDimensions().window;
    const [showThought, setShowThought] = useState<number>(-1);
    const [textInputValue, setTextInputValue] = React.useState('');
    const iconsSize = useFontSize(3 / PixelRatio.get());
    const styles = StyleSheet.create({
        container: {
            flexDirection: "row",
            flexWrap: "wrap",
            backgroundColor: "whitesmoke",
        },
        leftSideContainer: {
            width: width / 1.6,
            height: (width / 1.6 * 9 / 16),
            marginRight: isMobile() ? width / 3.3 : width / 4,

        },
        rightSideContainer: {
            position: "absolute",
            right: 0,
            left: 0,
            bottom: 0,
            top: 0,
            marginLeft: width / 1.6,

        },
        image: {
            width: "100%",
            height: "100%",
            backgroundColor: "whitesmoke",
            justifyContent: "center",
        },
        authorContainer: {
            height: "10%",
            margin: 5 / PixelRatio.get(),
            flexDirection: "row",
            alignContent: "center",
            alignItems: "center",

        },
        authorName: {
            marginLeft: 20 / PixelRatio.get(),
            fontSize: useFontSize(1),
            color: "black",
            fontWeight: "600"

        },
        commentsContainer: {
            height: "83%",
        },
        comment: {
            paddingRight: 5,
            flexDirection: "row",
            color: "black",
            marginTop: 10 / PixelRatio.get(),

            fontSize: useFontSize(1),
        },
        commentAuthor: {
            fontWeight: "bold",
            color: "black",
            fontSize: useFontSize(1),
        },
        commentMessage: {
            marginLeft: 5,
            color: "black",
            // display: "flex",
            fontWeight: isMobile() ? 'normal' : "200",
            fontSize: useFontSize(1),
        },
        footer: {
            padding: "1%",
            flex: 1

        },
        icons: {
            borderTopColor: "#e2e2e2b5",
            borderTopWidth: 1,
            flexDirection: "row",
            flex: 1,
            alignItems: "center"
        },
        commentIcon: {

            color: "black",
            marginRight: 10 / PixelRatio.get(),

        },
        heartIcon: {
            marginRight: 10 / PixelRatio.get()
        },

        commentInputWrapper: {
            borderTopColor: "#e2e2e2b5",
            borderTopWidth: 1,
            justifyContent: "center",
            flex: 1

        },
        commentInput: {
            fontSize: useFontSize(0.8),
            padding: 1 / PixelRatio.get(),



        },
        mcComment: {
            opacity: selectedImage.mcComments ? 1 : 0
        },
        modal: {
            zIndex: 0,
            flex: 1,
            left: isMobile() ? 25 : undefined,
            top: isMobile() ? "30%" : "20%",
            display: menuSlice.display ? "none" : "flex"

        },
        talk: {
            position: "absolute",
            zIndex: 5,
            bottom: "-40%",
            left: 0
        }

    });

    useEffect(() => {
        if (additionalImage) { return; }
        if (selectedImage?.image?.partials) {
            setAdditionalImage({ index: -1, image: null, length: Object.keys(selectedImage?.image?.partials).length });
        }
        if (!selectedImage.mcSeen) {
            store.dispatch(setInstaImage({ ...selectedImage, mcSeen: true }));
        }
        store.dispatch(setSeenImage(selectedImage?.image));
        if (!selectedImage.mcSeen && selectedImage.thoughts.length > 0) {
            setShowThought(0);
        }
        if (Platform.OS === "android" || Platform.OS === "ios") {
            return;
        }
        document.body.style.overflow = 'hidden';

    }, [selectedImage]);

    const onHeartPressed = () => {
        if (selectedImage.mcLiked) {
            store.dispatch(setInstaImage({ ...selectedImage, mcLiked: false }));
            return;
        }
        store.dispatch(setInstaImage({ ...selectedImage, mcLiked: true }));
    };
    const onCommentPressed = () => {
        inputTextRef.current?.focus();
    };

    const parseMessage = (message: string) => {
        let inputText = message;
        if (inputText) {
            const parsedMessage = inputText.split(/(\s)/g).map((item, i) => {
                if (/(#|@)[a-zA-Z0-9]+/g.test(item)) {
                    return <Text key={i} style={{ color: '#00376b' }}>{item.toLocaleLowerCase()}</Text>;
                }
                return item;
            });
            return <Text>{parsedMessage}</Text>;

        };
    };

    const getComment = (author: string, message: string) => {
        return <>
            <Text><Text style={styles.commentAuthor}>{author.toLocaleLowerCase()}: <Text style={styles.commentMessage}>{parseMessage(message)}</Text></Text>  </Text>
        </>;
    };
    const onThoughtClick = () => {
        if (typeof showThought === "number" && selectedImage.thoughts[showThought + 1]) {

            setShowThought(showThought => showThought + 1);
        } else {
            setShowThought(-1);

        }

    };
    const renderComments = () => {
        return (
            <ScrollView style={{ marginLeft: 10 }}
                onScroll={((event) => {
                    if (event.nativeEvent.contentOffset.y === 0) {
                        // scrollViewRef.current?.scrollTo(1);
                    }
                }

                )}
                ref={scrollViewRef}
            >
                {selectedImage.comments.map((comment, i) =>
                    <React.Fragment key={i}>
                        {comment.name ?
                            <View key={i} style={[styles.comment, i === 0 ? { paddingBottom: 20 / PixelRatio.get() } : {}]}>
                                <React.Fragment key={i}>
                                    {getComment(comment.name, comment.message)}
                                </React.Fragment>
                            </View> : <React.Fragment key={i}></React.Fragment>}
                    </React.Fragment>
                )}
                {
                    selectedImage.mcComments.map((mcComment, index) => (
                        <View key={mcComment + index} style={[styles.mcComment, styles.comment]}>
                            {
                                getComment(userName, mcComment)
                            }

                        </View>
                    ))

                }


            </ScrollView>

        );
    };
    const onSubmitComment = (key: NativeSyntheticEvent<TextInputSubmitEditingEventData>) => {
        if (!textInputValue.trim()) { return; }
        const tempSelectedImage: InstaImage = { ...selectedImage, mcComments: [...selectedImage.mcComments, textInputValue] };
        store.dispatch(setInstaImage(tempSelectedImage));
        setTextInputValue('');

    };
    useEffect(() => {

        scrollViewRef.current?.scrollToEnd({ animated: false });

    }, [textInputValue]);
    const onArrowRight = () => {
        if (!additionalImage) { return; }
        let additionalIndex = additionalImage?.index;

        if (additionalIndex + 1 < additionalImage.length) {
            additionalIndex++;
        }
        const additional = ImageClass._globalImages.get(Object.values(selectedImage?.image?.partials || [])?.[additionalIndex]?.key)?.url;
        if (additional) {

            setAdditionalImage({ image: additional, index: additionalIndex, length: additionalImage?.length || 0 });
        }
    };
    const onArrowLeft = () => {
        if (!additionalImage) { return; }
        let additionalIndex = additionalImage?.index;
        if (additionalIndex === 0) {

            return setAdditionalImage({ image: null, index: -1, length: additionalImage?.length || 0 });
            return;
        }

        additionalIndex--;

        const additional = ImageClass._globalImages.get(Object.values(selectedImage?.image?.partials || [])?.[additionalIndex]?.key)?.url;
        if (additional) {

            setAdditionalImage({ image: additional, index: additionalIndex, length: additionalImage?.length || 0 });
        }
    };


    return (

        <>
            <ScrollView style={styles.modal}>
                <KeyboardAvoidingView style={styles.container}>

                    <View style={styles.leftSideContainer}>
                        {/* <ImageBackground source={(additionalImage?.image ? additionalImage.image : ImageClass._globalImages.get(selectedImage.image.key)?.url as ImageBackgroundProps)} resizeMode={"cover"} style={[styles.image]} >
                            <View style={{ position: "absolute", marginRight: "2%", flexDirection: "row", width: "100%", padding: "1%", }}>
                                {additionalImage?.image ? <Icon selectable={false} onPress={() => onArrowLeft()} name={'chevron-circle-left'} style={{ color: "#b6b6b7" }} size={iconsSize} /> : <View style={{ flex: 1 }}></View>}
                                {additionalImage?.image === null ? <Icon selectable={false} onPress={() => onArrowRight()} name={'chevron-circle-right'} style={{ color: "#b6b6b7" }} size={iconsSize} /> : <></>}
                            </View>
                        </ImageBackground> */}
                        <View style={[styles.image]}>
                            <WaitForLoadImage source={(additionalImage?.image ? additionalImage.image : ImageClass._globalImages.get(selectedImage.image.key)?.url as ImageSourcePropType)} style={[styles.image]}></WaitForLoadImage>
                            <View style={{ position: "absolute", marginRight: "2%", flexDirection: "row", width: "100%", padding: "1%", }}>
                                {additionalImage?.image && additionalImage?.index > -1 ? <Icon selectable={false} onPress={() => onArrowLeft()} name={'chevron-circle-left'} style={{ color: "#b6b6b7", position: "absolute", left: 10 }} size={iconsSize} /> : <View style={{ flex: 1 }}></View>}
                                {additionalImage && additionalImage.index < (additionalImage?.length - 1 || 0) ? <Icon selectable={false} onPress={() => onArrowRight()} name={'chevron-circle-right'} style={{ color: "#b6b6b7", position: "absolute", right: 10 }} size={iconsSize} /> : <></>}
                            </View>
                        </View>


                    </View>
                    <View style={styles.rightSideContainer}>
                        <View style={styles.commentsContainer}>

                            <View style={styles.authorContainer}>
                                <View>
                                    <InstaAvatar size={useFontSize(4)} profilePic={instaProfile.instaProfileImage.url}></InstaAvatar>
                                </View>
                                <Text style={styles.authorName}>{instaProfile.instaProfileName} • Following</Text>
                            </View>
                            <View style={{
                                borderBottomColor: '#ccc4c44f',
                                borderBottomWidth: 1,
                            }} />

                            {renderComments()}
                        </View>
                        <View style={styles.footer}>
                            <View style={styles.icons}>
                                <Icon selectable={false} name={selectedImage.mcLiked ? 'heart' : "heart-o"} size={useFontSize(3 / PixelRatio.get())} style={styles.heartIcon} color={selectedImage.mcLiked ? "red" : "black"} onPress={() => onHeartPressed()} />
                                <Icon selectable={false} name="comment-o" size={useFontSize(3 / PixelRatio.get())} style={styles.commentIcon} onPress={() => onCommentPressed()} />
                                <Text style={{ color: "black", fontSize: useFontSize(1 / PixelRatio.get()) }}>{nFormatter(selectedImage.likes + (selectedImage.mcLiked ? 1 : 0))} likes</Text>
                            </View>
                            <KeyboardAvoidingView style={styles.commentInputWrapper}>
                                <TextInput
                                    ref={(ref) => { inputTextRef.current = ref; }}
                                    focusable
                                    value={textInputValue}
                                    // onChangeText={text => setValue(text)}
                                    onSubmitEditing={(a) => { onSubmitComment(a); }}
                                    placeholder={`Add a comments...`}
                                    onChangeText={text => setTextInputValue(text)}
                                    keyboardAppearance={"dark"}
                                    disableFullscreenUI
                                    editable
                                    maxLength={100}
                                    style={styles.commentInput}
                                />

                            </KeyboardAvoidingView>

                        </View>
                    </View>
                </KeyboardAvoidingView>
            </ScrollView>

            {showThought > -1 ?
                <View style={{ height, width, position: "absolute" }}>

                    <TouchableWithoutFeedback onPress={() => onThoughtClick()} style={{ height, width, position: "absolute", zIndex: 100 }}>
                        <View style={{ width: "100%", height: "100%", position: "absolute" }}>

                            {selectedImage.thoughts?.length > 0 ?
                                <TTalkContainer key={"talk"}
                                    talkStyle={{ position: "absolute", width: "100%", bottom: 0, height: "20%", backgroundColor: "#0000009c" }}
                                    talkObject={{ text: selectedImage.thoughts[showThought], options: { think: true }, character: mc }}
                                    numberOfLines={9999} />

                                : <></>}
                        </View>
                    </TouchableWithoutFeedback>
                </View> :
                <></>}
        </>
    );
});



